<template>
  <div>
    <v-carousel hide-controls hide-delimiters lazy class="image-height" v-if="image_url">
      <v-carousel-item :src="image_url"></v-carousel-item>
    </v-carousel>
    <v-container>
      <vcl-list v-if="!loaded"></vcl-list>
      <h1 class="display-1 green--text">{{ title }}</h1>
      <p class="body-1 grey--text mb-3" v-if="loaded">{{ dateFormat }} &#9679; {{ fromNow }}</p>
      <p class="subheading">{{ content }}</p>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { VclList } from 'vue-content-loading';
export default {
  components:{
    VclList
  },
  data(){
    return {
      image_url: '',
      title: '',
      content: '',
      dateFormat: '',
      fromNow: '',
      loaded: false
    }
  },
  async created(){
    try{
      // Backend will change 
      const newsData = await axios.get('/api/news')
      const found = newsData.data.find(val => val.news_id.toString() === this.$route.params.id ? val : null)
      this.image_url = found.image_url
      this.title = found.news_title
      this.content = found.news_content
      this.dateFormat = moment(found.created_at).format('MMMM D, YYYY')
      this.fromNow = moment(found.created_at).fromNow()
      this.loaded = true
    }catch(e){
      console.log(e)
    }
    
  }
}
</script>
<style scoped>
.image-height{
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage/NewsArticle.vue